import type { SelectorOption } from '../../types';

export const getOptions = <Value extends string | number>(
  options: SelectorOption<Value | null>[],
  option?: SelectorOption<Value | null> | null,
  clearOptionLabel = 'Select'
): SelectorOption<Value | null>[] => {
  const filteredOptions = options.filter((o) => o.value !== null && (!option || o.value !== option.value));

  if (option && option.value === null) {
    return [{ value: null, label: option.label || clearOptionLabel }, ...filteredOptions];
  }

  const optionList = [{ value: null, label: clearOptionLabel }, ...(option ? [option] : []), ...filteredOptions];

  const seen = new Set<Value | null>();
  return optionList.filter((o) => {
    if (seen.has(o.value)) return false;
    seen.add(o.value);
    return true;
  });
};
